import { render, staticRenderFns } from "./DialogCardFooter.vue?vue&type=template&id=8a5c8ac2"
import script from "./DialogCardFooter.vue?vue&type=script&lang=js"
export * from "./DialogCardFooter.vue?vue&type=script&lang=js"
import style0 from "./DialogCardFooter.vue?vue&type=style&index=0&id=8a5c8ac2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports